/**
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const StyleRemplissage = require('../types/StyleRemplissage')
const kernel = require('../kernel/kernel')
const CCercle = require('./CCercle')
const CSurfaceAncetre = require('./CSurfaceAncetre')
const CSurface = require('./CSurface')
module.exports = CSurfaceDisque

/**
 * Surface délimité par un cercle.
 * @constructor
 * @extends CSurface
 * @param {CListeObjets} listeProprietaire : La liste propriétaire.
 * @param {CImplementationProto} impProto : null ou la construction propriétaire.
 * @param {Boolean} estElementFinal : true si élément final de construction.
 * @param {mtg32.Color} couleur : La couleur.
 * @param {Boolean} masque : true si l'objet est masqué.
 * @param {StyleRemplissage} styleRemplissage : Entier donnant le style de remplissage.
 * @param {CCercle} bord : Le cercle bord de la surface.
 * @returns {CSurfaceDisque}
 */
function CSurfaceDisque (listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord) {
  if (arguments.length === 1) CSurface.call(this, listeProprietaire);
  else {
    CSurface.call(this, listeProprietaire, impProto, estElementFinal, couleur, masque, styleRemplissage, bord);
  }
  this.cercle = new CCercle(null);
}
CSurfaceDisque.prototype = new CSurface();
CSurfaceDisque.prototype.constructor = CSurfaceDisque;
CSurfaceDisque.prototype.superClass = "CSurface";
CSurfaceDisque.prototype.className = "CSurfaceDisque";

CSurfaceDisque.prototype.getClone = function(listeSource, listeCible) {
  var ind1 = listeSource.indexOf(this.bord);
  var ind2 = listeSource.indexOf(this.impProto);
  return new CSurfaceDisque(listeCible, listeCible.get(ind2, "CImplementationProto"),
    this.estElementFinal, this.couleur, this.masque, this.styleRemplissage, listeCible.get(ind1, "CCercle"));
};
CSurfaceDisque.prototype.ajouteAntecedents = function(liste) {
  liste.add(this.bord);
};
CSurfaceDisque.prototype.positionne = function(infoRandom, dimfen) {
  CSurface.prototype.positionne.call(this, infoRandom, dimfen);
  this.cercle.setClone(this.bord);
};
CSurfaceDisque.prototype.setClone = function(ptel) {
  CSurfaceAncetre.prototype.setClone.call(this, ptel);
  this.cercle.setClone(ptel.cercle);
};
CSurfaceDisque.prototype.createg = function(svg, couleurFond, transparence) {
  var styleRemplissage,g,opacity,style,color;
  // color = this.couleur.rgb() Modifié vesion 4.9.9.4
  color = this.color;
  styleRemplissage = this.styleRemplissage;
  g = kernel.cens("circle",{
    cx : this.cercle.centre_x,
    cy : this.cercle.centre_y,
    r : this.cercle.rayon
  });
  switch (styleRemplissage) {
    case StyleRemplissage.quadrillagePleinTransp:
    case StyleRemplissage.quadrillagePlein:
      opacity = (styleRemplissage === StyleRemplissage.quadrillagePleinTransp) ? transparence : 1;
      style = "stroke:none;";
      style += "fill-opacity:"+opacity+";";
      style += "fill:"+color+";";
      g.setAttribute("style", style);
      break;
     default :
      style = "stroke:none;"+"fill:url(#" + this.listeProprietaire.id +this.index+"mtg32pattern);";
      this.createPattern();
      g.setAttribute("style", style);
  }
  g.setAttribute("pointer-events", "none");
  return g;
};
CSurfaceDisque.prototype.update = function(svg, couleurFond, transparence) {
  var g = this.g;
  // svg.replaceChild(this.createg(transparence),g)
  g.removeAttribute("cx");
  g.removeAttribute("cx");
  g.removeAttribute("r");
  g.setAttribute("cx",this.cercle.centre_x);
  g.setAttribute("cy",this.cercle.centre_y);
  g.setAttribute("r",this.cercle.rayon);
};
CSurfaceDisque.prototype.read = function(inps, list){
  CSurface.prototype.read.call(this, inps, list);
  this.cercle = new CCercle(null);
};
